import React, { useEffect, useState } from 'react';
import PhoneIcon from '../assets/PhoneIcon.png'
import EmailIcon from '../assets/EmailIcon.png'
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import { sendTestMatomoEvent } from '../Analytics/MatomoManager/matomoTest';
import { Translate } from './LanguageChanger';
let resolution = window.RESOLUTION;


// #2F0048
// const HelpSupport = ({ data }) => {
//   // console.log('help & support', data);
//   // const [helpSupports] = useState(data);
//   const [helpSupports] = useState({
//     title: "Help & Support",
//     description: "Use Prasar Bharti App Or Website To Access Help & Support",
//     steps: [
//       "1. Open app or website and log in using +91 73******",
//       "2. Go to side menu",
//       "3. Go to help & support"
//     ],
//     customerSupport: {
//       contactNumber: "+91 80100443741",
//       emailAddress: "prasarbharti@gmail.com"
//     }
//   });

//   const styles = {
//     HelpSupportContainer: {
//       display: 'flex',
//       flexDirection: 'column',
//       background: 'transparent',
//       width: '100vw',
//       height: '100vh',
//       backgroundSize: 'cover',
//       backgroundPosition: 'center', // Center the background image
//       backgroundRepeat: 'no-repeat', // Do not repeat the background image
//       color: '#D0D0D0',
//       fontSize: '18px'
//     },
//   };
//   return (
//     <div style={styles.HelpSupportContainer} dangerouslySetInnerHTML={{ __html: helpSupports }}>
//       <div>
//         <h1>{helpSupports.title}</h1>
//         <p>{helpSupports.description}</p>
//         <ul>
//           {helpSupports.steps.map((step, index) => (
//             <li key={index}>{step}</li>
//           ))}
//         </ul>
//         <div>
//           <h2>Customer Support</h2>
//           <p>Contact Number: {helpSupports.customerSupport.contactNumber}</p>
//           <p>Email Address: {helpSupports.customerSupport.emailAddress}</p>
//         </div>
//       </div>
//     </div>
//   );
// };
// export default HelpSupport;



// const [helpSupports] = useState({
//   title: "Help & Support",
//   description: "Use Prasar Bharti App Or Website To Access Help & Support",
//   steps: [
//     "1. Open app or website and log in using +91 73******",
//     "2. Go to side menu",
//     "3. Go to help & support"
//   ],
//   customerSupport: {
//     contactNumber: "+91 80100443741",
//     emailAddress: "prasarbharti@gmail.com"
//   }
// });


// <div>
//   <h1>{helpSupports.title}</h1>
//   <p>{helpSupports.description}</p>
//   <ul>
//     {helpSupports.steps.map((step, index) => (
//       <li key={index}>{step}</li>
//     ))}
//   </ul>
//   <div>
//     <h2>Customer Support</h2>
//     <p>Contact Number: {helpSupports.customerSupport.contactNumber}</p>
//     <p>Email Address: {helpSupports.customerSupport.emailAddress}</p>
//   </div>
// </div>


const HelpSupport = ({ data, isLogedIn }) => {
  // If you want to use the passed `data` prop, you can replace the default state
  // const [helpSupports] = useState(data);

  const mobileNumber = localStorage.getItem("mobileNo").slice(0,2)
  console.log(mobileNumber, "test")

  const [helpSupports] = useState({
    title: <Translate langKey={"Help&Support"}/>,
    description: "Use Prasar Bharti App Or Website To Access Help & Support",
    steps: [
      `1. Open app or website and log in using ${isLogedIn ? `+91 ${mobileNumber}XXXXXXXX` : 'your mobile number.'}`,
      "2. Go to side menu",
      "3. Go to help & support"
    ],
    customerSupport: {
      contactNumber: "18002020293",
      emailAddress: "support@wavespb.com"
    }
  });

    useEffect(() => {
    // Matomo Event
    sendTestMatomoEvent({ eventCategory: `Page`, eventAction: `View`, eventName: `HelpAndSupport`, url:"help-support" });
  }, [])


  const styles = {
    HelpSupportContainer: {
      background: `url(${solidbackgroundimg})`,
      display: 'flex',
      flexDirection: 'column',
      // background: 'transparent',
      width: '92vw',
      height: '74vh',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      color: '#D0D0D0',
      fontSize: '18px',
      padding: '20px',
      overflow: 'hidden',
    },
  };

  return (
    <div style={styles.HelpSupportContainer}>
      <h1 style={{
        fontFamily: "Anek Latin",
        fontWeight:"500",
        color:"#ffff"
      }}>{helpSupports.title}</h1>
      <p style={{
         color:"#B5B5B5",
        fontFamily: "Anek Latin",
        fontWeight:"400"
      }}>{helpSupports.description}</p>
      <ul style={{ listStyleType: 'none', marginLeft: "-28px", marginTop:"-2px", color:"#B5B5B5", }}>
        {helpSupports.steps.map((step, index) => (
          <li key={index} style={{marginTop:"10px"}}>{step}</li>
        ))}
      </ul>
           <pre style={{    fontFamily: "'Anek Latin', sans-serif",fontSize:"1.4rem",width:"12.125rem",heiht:"1.42rem",color:"#5B5B5B",letterSpacing: "0.5px",fontWeight: "500"}}>CUSTOMER SUPPORT</pre>
      <div style={{ display: "flex", justifyContent: "start", gap: "50px", paddingTop: " 10px" }}>
        <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
          {/* Icon Container */}
          <div
            style={{
              // padding: "16px",
              backgroundColor: "#2F0048",
              borderRadius: "6px",
              height: "58px",
              width: "57px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={EmailIcon}
              alt="phone icon"
              style={{ width: "30px", height: "30px", objectFit: "contain" }}
            />
          </div>

          {/* Text Content */}
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <p
              style={{
                color: "#A4A4A4",
                fontSize: "18px",
                lineHeight: "19.8px",
                margin: 0,
              }}
            >
              <Translate langKey={"contact_number"}/>
            </p>
            <p
              style={{
                color: "#FFFFFF",
                fontSize: "18px",
                lineHeight: "19.8px",
                margin: 0,
              }}
            >
              {helpSupports.customerSupport.contactNumber}
            </p>
          </div>

        </div>
        <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
          {/* Icon Container */}
          <div
            style={{
              // padding: "16px",
              backgroundColor: "#2F0048",
              borderRadius: "6px",
              height: "60px",
              width: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={PhoneIcon}
              alt="email icon"
              style={{ width: "36px", height: "28px", objectFit: "contain" }}
            />
          </div>

          {/* Text Content */}
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <p
              style={{
                color: "#A4A4A4",
                fontSize: "18px",
                lineHeight: "19.8px",
                margin: 0,
              }}
            >
              <Translate langKey={"acc-email"}/>
            </p>
            <p
              style={{
                color: "#FFFFFF",
                fontSize: "18px",
                lineHeight: "19.8px",
                margin: 0,
              }}
            >
              {helpSupports.customerSupport.emailAddress}
            </p>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "12px", position: "absolute", bottom: "4rem", width: "100%", textAlign: "center", left: 0 }}>
            <p
              style={{
                color: "#A4A4A4",
                fontSize: "2rem",
                lineHeight: "19.8px",
                margin: 0,
              }}
            >
              {<Translate langKey={"app_version"}/>} : {window.APP_VERSION}
            </p>
          </div>

        </div>
        
      </div>

    </div>
  );
};

export default HelpSupport;

